export default "__VITE_ASSET__2e868cd7__"